import React, { useState, useContext, useEffect } from 'react';
import { IonPage, IonHeader, IonToolbar, IonButtons, IonTitle, IonContent, IonToast, IonLoading, IonBackButton, IonText, IonIcon, IonButton } from '@ionic/react';
import { withRouter } from 'react-router';

import Firebase, { withFirebase } from '../services/Firebase';
import QrReader from 'react-qr-reader';
import QRCode from 'qrcode.react';
import { AuthUserContext } from '../services/Session';

import './QRCodePage.css'
import { qrCode, cameraOutline, closeOutline } from 'ionicons/icons';

interface FormProps {
  history: any,
  firebase: Firebase,
}

const QRCodePage: React.FC<FormProps> = ({ history, firebase }) => {
  const [error, setError] = useState<Error>();
  const [loading, setLoading] = useState(false);
  const [qrReader, setQrReader] = useState(false);
  const [reading, setReading] = useState(false);
  const user = useContext(AuthUserContext);
  const [groups, setGroups] = useState<any[]>([]);
  
  useEffect(() => {
    if(!user) return;
    setLoading(true);
    const unsubscribe = firebase
    .groups()
    .where('userId', '==', user.uid)
    .limit(1)
    .orderBy('name', 'asc')
    .onSnapshot((querySnapshot) => {
      const groups:any[] = [];
      querySnapshot.forEach((doc) => {
        const group = {
          id: doc.id,
          ...doc.data()
        };
        groups.push(group);
      });
      setLoading(false);
      setGroups(groups);
    }, error => {
      setLoading(false);
      setError(error);
    })
    return () => {
      // Nettoyage de l'abonnement
      unsubscribe();
    };
  }, [firebase, user]);
  
  const handleCode = (data: string | null) => {
    if (reading || !data) return
    setReading(true)
    setLoading(true)
    // TODO replace by cloud function to not allow
    // to join existing group by brut force
    const docRef = firebase.users().doc(user?.uid);
    docRef.update({
      groupIds: firebase.arrayUnion(data)
    })
    .then (() => {
      setLoading(false);
      setReading(false)
      history.goBack();
    })
    .catch(error => {
      setError(error);
      setReading(false)
      setLoading(false);
    });
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot='start'>
            <IonBackButton defaultHref='/' icon={closeOutline} text='' />
          </IonButtons>
          <IonTitle>Rejoindre un groupe</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen className="ion-padding ion-text-center">
        <IonLoading isOpen={loading} />
        <IonToast
          isOpen={!!error}
          message={(error || { message: 'Oups, une erreure s\'produite...'}).message}
          duration={8000}
          color="danger"
        />
        {
          qrReader
          ? <div className='qrcode_container'>
              <IonText color="primary" className='ion-margin-top'>
                Scannez un QRCode pour rejoindre un réseau
              </IonText>
              <QrReader
                delay={1000}
                className='roundedBorder'
                onError={(e) => {setError(e)}}
                onScan={handleCode}
                style={{ width: '80%' }}
              />
              <IonButton fill='clear' className='ion-margin-top' onClick={() => setQrReader(false)}>
                <IonIcon icon={qrCode}/>&nbsp;Afficher votre QRCode
              </IonButton>
            </div>
          : <div className='qrcode_container'>
              <IonText color="primary" className='ion-margin-top'>
                Partagez ce QRCode avec votre réseau
              </IonText>
              <QRCode value={(groups[0] || { id: 'oops' }).id} fgColor='#eb445a' size={192} />
              <IonButton fill='clear' className='ion-margin-top' onClick={() => setQrReader(true)}>
                <IonIcon icon={cameraOutline}/>&nbsp;Scanner un QRCode
              </IonButton>
            </div>
        }
      </IonContent>
    </IonPage>
  );
};

export default withRouter(withFirebase(QRCodePage));
